import * as $ from 'jquery';
import 'slick-carousel';

class CaseStudy {

  init = () => {
    this.handleSliderInit();
  };

  handleSliderInit = () => {
        
    const mainSlickSettings: JQuerySlickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.case-study__main-slider__arrows .arrow-prev'),
      nextArrow: $('.case-study__main-slider__arrows .arrow-next'),
      asNavFor: '.case-study__small-slider__left, .case-study__small-slider__right'
    };

    const thumbnailSlickSettings: JQuerySlickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.case-study__small-slider__arrows--left .arrow-prev'),
      nextArrow: null,
      asNavFor: '.case-study__small-slider__right, .case-study__main-slider'
    };
    
    const thumbnailSlickSetting: JQuerySlickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: null,
      nextArrow: $('.case-study__small-slider__arrows--right .arrow-next'),
      asNavFor: '.case-study__small-slider__left, .case-study__main-slider'
    };

    $(".case-study__main-slider").on('init', function(){
      $(this).parents(".case-study").addClass("case-study--initialized");
    });

    $(".case-study__small-slider__right").slick(thumbnailSlickSetting);
    $(".case-study__small-slider__left").slick(thumbnailSlickSettings);
    $(".case-study__main-slider").slick(mainSlickSettings)

  }
}

const CaseStudyInstance = new CaseStudy();
CaseStudyInstance.init();

export { CaseStudy, CaseStudyInstance };
